import { MatchConfig } from '@libs/src/models/match.interfaces';
import {
  getCustomSegmentsFromSelections,
  getRoleNamesFromSelections,
} from '@main-client/src/app/account/account.helpers';
import { MatchSelections } from '@main-client/src/app/group-intro-selections-form/match-selections';

import flatten from 'lodash-es/flatten';
import values from 'lodash-es/values';

export function hasEmptySelections(
  { roles, customSegments }: MatchSelections,
  matchConfig: MatchConfig,
) {
  const selectedRoleNames = getRoleNamesFromSelections(roles, true);
  const selectedCustomSegments = getCustomSegmentsFromSelections(
    customSegments,
    true,
  );
  const roleSelectionIsEmptyAndRequired =
    'required' === matchConfig.match_segment_level &&
    0 === selectedRoleNames.length;
  const selections = [
    ...selectedRoleNames,
    ...flatten(values(selectedCustomSegments)),
  ];
  const allSelectionsAreEmpty = 0 === selections.length;
  return roleSelectionIsEmptyAndRequired || allSelectionsAreEmpty;
}
